@use "styles/abstracts/mixins/typography" as t;

.loadMoreButton {
  display: block;
  margin: 0 auto 0;
}
